/* tslint:disable */
/* eslint-disable */
/**
 * Orders and payments
 * Placeholder description of the order & payment instruction service. Detailed description to be provided by Monavate team.
 *
 * The version of the OpenAPI document: 1.33.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreatePaymentRequest } from '../models';
// @ts-ignore
import type { CreatePaymentResponse } from '../models';
// @ts-ignore
import type { NotFoundError } from '../models';
// @ts-ignore
import type { PaymentResponse } from '../models';
// @ts-ignore
import type { PaymentsResponse } from '../models';
// @ts-ignore
import type { PreconditionFailedError } from '../models';
// @ts-ignore
import type { UpdatePaymentRequest } from '../models';
// @ts-ignore
import type { ValidationError } from '../models';
/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Triggering manual payment execution
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePayment: async (paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('activatePayment', 'paymentId', paymentId)
            const localVarPath = `/payments/{payment-id}/activate`
                .replace(`{${"payment-id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel payment by ID
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPayment: async (paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('cancelPayment', 'paymentId', paymentId)
            const localVarPath = `/payments/{payment-id}`
                .replace(`{${"payment-id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new payment
         * @param {CreatePaymentRequest} createPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayment: async (createPaymentRequest: CreatePaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPaymentRequest' is not null or undefined
            assertParamExists('createPayment', 'createPaymentRequest', createPaymentRequest)
            const localVarPath = `/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a payment by ID
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayment: async (paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('getPayment', 'paymentId', paymentId)
            const localVarPath = `/payments/{payment-id}`
                .replace(`{${"payment-id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Link transaction with payment
         * @param {string} paymentId Payment ID.
         * @param {string} transactionId Transaction ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkTransaction: async (paymentId: string, transactionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('linkTransaction', 'paymentId', paymentId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('linkTransaction', 'transactionId', transactionId)
            const localVarPath = `/payments/{payment-id}/link/{transaction-id}`
                .replace(`{${"payment-id"}}`, encodeURIComponent(String(paymentId)))
                .replace(`{${"transaction-id"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all payments
         * @param {string} [cardId] Filter by a card ID.
         * @param {string} [orderReference] Filter by order reference number.
         * @param {string} [orderId] Filter by order id.
         * @param {Array<string>} [status] Filter by status
         * @param {string} [currency] Filter by currency
         * @param {ListPaymentsTypeEnum} [type] Filter by payment type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayments: async (cardId?: string, orderReference?: string, orderId?: string, status?: Array<string>, currency?: string, type?: ListPaymentsTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cardId !== undefined) {
                localVarQueryParameter['cardId'] = cardId;
            }

            if (orderReference !== undefined) {
                localVarQueryParameter['orderReference'] = orderReference;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies a payment
         * @summary Modify payment
         * @param {UpdatePaymentRequest} updatePaymentRequest 
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayment: async (updatePaymentRequest: UpdatePaymentRequest, paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePaymentRequest' is not null or undefined
            assertParamExists('updatePayment', 'updatePaymentRequest', updatePaymentRequest)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('updatePayment', 'paymentId', paymentId)
            const localVarPath = `/payments/{payment-id}`
                .replace(`{${"payment-id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Triggering manual payment execution
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activatePayment(paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activatePayment(paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.activatePayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel payment by ID
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelPayment(paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelPayment(paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.cancelPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new payment
         * @param {CreatePaymentRequest} createPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPayment(createPaymentRequest: CreatePaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPayment(createPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.createPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a payment by ID
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayment(paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayment(paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Link transaction with payment
         * @param {string} paymentId Payment ID.
         * @param {string} transactionId Transaction ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkTransaction(paymentId: string, transactionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkTransaction(paymentId, transactionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.linkTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all payments
         * @param {string} [cardId] Filter by a card ID.
         * @param {string} [orderReference] Filter by order reference number.
         * @param {string} [orderId] Filter by order id.
         * @param {Array<string>} [status] Filter by status
         * @param {string} [currency] Filter by currency
         * @param {ListPaymentsTypeEnum} [type] Filter by payment type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPayments(cardId?: string, orderReference?: string, orderId?: string, status?: Array<string>, currency?: string, type?: ListPaymentsTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPayments(cardId, orderReference, orderId, status, currency, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.listPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modifies a payment
         * @summary Modify payment
         * @param {UpdatePaymentRequest} updatePaymentRequest 
         * @param {string} paymentId Payment ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePayment(updatePaymentRequest: UpdatePaymentRequest, paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePayment(updatePaymentRequest, paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.updatePayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Triggering manual payment execution
         * @param {PaymentsApiActivatePaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePayment(requestParameters: PaymentsApiActivatePaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.activatePayment(requestParameters.paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel payment by ID
         * @param {PaymentsApiCancelPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPayment(requestParameters: PaymentsApiCancelPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentResponse> {
            return localVarFp.cancelPayment(requestParameters.paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new payment
         * @param {PaymentsApiCreatePaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayment(requestParameters: PaymentsApiCreatePaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreatePaymentResponse> {
            return localVarFp.createPayment(requestParameters.createPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a payment by ID
         * @param {PaymentsApiGetPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayment(requestParameters: PaymentsApiGetPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentResponse> {
            return localVarFp.getPayment(requestParameters.paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Link transaction with payment
         * @param {PaymentsApiLinkTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkTransaction(requestParameters: PaymentsApiLinkTransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.linkTransaction(requestParameters.paymentId, requestParameters.transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all payments
         * @param {PaymentsApiListPaymentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayments(requestParameters: PaymentsApiListPaymentsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaymentsResponse> {
            return localVarFp.listPayments(requestParameters.cardId, requestParameters.orderReference, requestParameters.orderId, requestParameters.status, requestParameters.currency, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * Modifies a payment
         * @summary Modify payment
         * @param {PaymentsApiUpdatePaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayment(requestParameters: PaymentsApiUpdatePaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentResponse> {
            return localVarFp.updatePayment(requestParameters.updatePaymentRequest, requestParameters.paymentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activatePayment operation in PaymentsApi.
 * @export
 * @interface PaymentsApiActivatePaymentRequest
 */
export interface PaymentsApiActivatePaymentRequest {
    /**
     * Payment ID.
     * @type {string}
     * @memberof PaymentsApiActivatePayment
     */
    readonly paymentId: string
}

/**
 * Request parameters for cancelPayment operation in PaymentsApi.
 * @export
 * @interface PaymentsApiCancelPaymentRequest
 */
export interface PaymentsApiCancelPaymentRequest {
    /**
     * Payment ID.
     * @type {string}
     * @memberof PaymentsApiCancelPayment
     */
    readonly paymentId: string
}

/**
 * Request parameters for createPayment operation in PaymentsApi.
 * @export
 * @interface PaymentsApiCreatePaymentRequest
 */
export interface PaymentsApiCreatePaymentRequest {
    /**
     * 
     * @type {CreatePaymentRequest}
     * @memberof PaymentsApiCreatePayment
     */
    readonly createPaymentRequest: CreatePaymentRequest
}

/**
 * Request parameters for getPayment operation in PaymentsApi.
 * @export
 * @interface PaymentsApiGetPaymentRequest
 */
export interface PaymentsApiGetPaymentRequest {
    /**
     * Payment ID.
     * @type {string}
     * @memberof PaymentsApiGetPayment
     */
    readonly paymentId: string
}

/**
 * Request parameters for linkTransaction operation in PaymentsApi.
 * @export
 * @interface PaymentsApiLinkTransactionRequest
 */
export interface PaymentsApiLinkTransactionRequest {
    /**
     * Payment ID.
     * @type {string}
     * @memberof PaymentsApiLinkTransaction
     */
    readonly paymentId: string

    /**
     * Transaction ID.
     * @type {string}
     * @memberof PaymentsApiLinkTransaction
     */
    readonly transactionId: string
}

/**
 * Request parameters for listPayments operation in PaymentsApi.
 * @export
 * @interface PaymentsApiListPaymentsRequest
 */
export interface PaymentsApiListPaymentsRequest {
    /**
     * Filter by a card ID.
     * @type {string}
     * @memberof PaymentsApiListPayments
     */
    readonly cardId?: string

    /**
     * Filter by order reference number.
     * @type {string}
     * @memberof PaymentsApiListPayments
     */
    readonly orderReference?: string

    /**
     * Filter by order id.
     * @type {string}
     * @memberof PaymentsApiListPayments
     */
    readonly orderId?: string

    /**
     * Filter by status
     * @type {Array<string>}
     * @memberof PaymentsApiListPayments
     */
    readonly status?: Array<string>

    /**
     * Filter by currency
     * @type {string}
     * @memberof PaymentsApiListPayments
     */
    readonly currency?: string

    /**
     * Filter by payment type
     * @type {'bank' | 'card'}
     * @memberof PaymentsApiListPayments
     */
    readonly type?: ListPaymentsTypeEnum
}

/**
 * Request parameters for updatePayment operation in PaymentsApi.
 * @export
 * @interface PaymentsApiUpdatePaymentRequest
 */
export interface PaymentsApiUpdatePaymentRequest {
    /**
     * 
     * @type {UpdatePaymentRequest}
     * @memberof PaymentsApiUpdatePayment
     */
    readonly updatePaymentRequest: UpdatePaymentRequest

    /**
     * Payment ID.
     * @type {string}
     * @memberof PaymentsApiUpdatePayment
     */
    readonly paymentId: string
}

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * 
     * @summary Triggering manual payment execution
     * @param {PaymentsApiActivatePaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public activatePayment(requestParameters: PaymentsApiActivatePaymentRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).activatePayment(requestParameters.paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel payment by ID
     * @param {PaymentsApiCancelPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public cancelPayment(requestParameters: PaymentsApiCancelPaymentRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).cancelPayment(requestParameters.paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new payment
     * @param {PaymentsApiCreatePaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public createPayment(requestParameters: PaymentsApiCreatePaymentRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).createPayment(requestParameters.createPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a payment by ID
     * @param {PaymentsApiGetPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getPayment(requestParameters: PaymentsApiGetPaymentRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getPayment(requestParameters.paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Link transaction with payment
     * @param {PaymentsApiLinkTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public linkTransaction(requestParameters: PaymentsApiLinkTransactionRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).linkTransaction(requestParameters.paymentId, requestParameters.transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all payments
     * @param {PaymentsApiListPaymentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public listPayments(requestParameters: PaymentsApiListPaymentsRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).listPayments(requestParameters.cardId, requestParameters.orderReference, requestParameters.orderId, requestParameters.status, requestParameters.currency, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modifies a payment
     * @summary Modify payment
     * @param {PaymentsApiUpdatePaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public updatePayment(requestParameters: PaymentsApiUpdatePaymentRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).updatePayment(requestParameters.updatePaymentRequest, requestParameters.paymentId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListPaymentsTypeEnum = {
    Bank: 'bank',
    Card: 'card'
} as const;
export type ListPaymentsTypeEnum = typeof ListPaymentsTypeEnum[keyof typeof ListPaymentsTypeEnum];
